<template>
  <el-drawer
    custom-class="drawer_deepseek"
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    width="1295px"
  >
    <template #header="{ titleId, titleClass }">
      <el-space class="header" :id="titleId" :class="titleClass">
        <img src="@/assets/img/tools_icon10.png" width="50" />
        <strong>deepseek</strong>
        <div>(目前公测期间免费使用)</div>
        <div class="divider"></div>
      </el-space>
    </template>
    <div class="container">
      <div class="content_list" ref="scrollRef">
        <div
          class="item"
          v-for="(item, index) in formData.messages"
          :key="index"
        >
          <div class="user" v-if="item.role === 'user'">
            <div class="content">{{ item.content }}</div>
          </div>
          <div class="assistant" v-else-if="item.role === 'assistant'">
            <div class="content">
              <el-space class="mb10">
                <img src="@/assets/img/tools_icon10.png" width="30" />
                <strong>deepseek</strong>
              </el-space>
              <div v-html="item.content"></div>
            </div>
            <div class="tools">
              <span class="t1">{{ item.time }}</span>
              <span class="t2" @click="copyHandle(item.content)">
                <img src="@/assets/img/PopupTool8_icon1.png" />
              </span>
            </div>
          </div>
        </div>
        <div class="item" v-show="reactiveData.loading === 2">
          <div class="assistant">
            <div class="content">
              <el-icon class="is-loading"><Loading /></el-icon>
            </div>
          </div>
        </div>
      </div>
      <el-form
        class="form"
        ref="formRef"
        :model="formData"
        :rules="rules"
        hide-required-asterisk
        @submit.stop.prevent="submitForm(formRef)"
      >
        <el-row class="mb20" justify="space-between">
          <div>
            <el-button @click="text1Handle">推广文案</el-button>
            <el-button @click="text2Handle">小红书</el-button>
          </div>
          <div>
            <el-button @click="clearHandle">
              <img class="mr5" src="@/assets/img/PopupTool8_icon4.png" />
              新对话
            </el-button>
          </div>
        </el-row>
        <el-form-item prop="keyword">
          <div class="input">
            <el-input
              v-model="formData.keyword"
              placeholder="在这里直接输入问题"
              type="textarea"
              resize="none"
            />
            <el-row justify="space-between" align="middle">
              <el-space>
                <div
                  class="btn1"
                  :class="{ active: formData.model === 'deepseek-reasoner' }"
                  @click="modelChangeHandle"
                >
                  <img class="mr5" src="@/assets/img/PopupTool8_icon2.png" />
                  深度思考
                </div>
                <div
                  class="btn1"
                  :class="{ active: formData.enable_search === true }"
                  @click="formData.enable_search = !formData.enable_search"
                >
                  <img class="mr5" src="@/assets/img/PopupTool8_icon5.png" />
                  联网搜索
                </div>
              </el-space>
              <el-button
                class="submit hover"
                @click="submitForm(formRef)"
                :disabled="reactiveData.loading > 0"
              >
                <img src="@/assets/img/PopupTool8_icon3.png" />
              </el-button>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script setup>
import { toRefs, ref, reactive, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { copyText } from 'vue3-clipboard'
import { DeepSeekCheck } from '@/utils/api'
import { Close, Loading } from '@element-plus/icons-vue'
import moment from 'moment'

const store = useStore()
const { state } = store
const { loading, userInfo } = toRefs(state)

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const formRef = ref()

const rules = reactive({
  keyword: [{ required: true, message: '请输入', trigger: 'blur' }],
})

const reactiveData = reactive({
  loading: 0,
  controller: new AbortController(),
})

const formData = reactive({
  keyword: '',
  model: 'deepseek-chat',
  messages: [],
  enable_search: false,
})

const scrollRef = ref(null)
const scrollHandle = () => {
  if (scrollRef.value) {
    scrollRef.value.scrollTop = scrollRef.value.scrollHeight
  }
}
watch(
  () => formData.messages,
  () => {
    nextTick(scrollHandle)
  },
  { deep: true }
)

// const submitHandle = async () => {
//   const { data: res } = await DeepSeek(
//     { messages: formData.messages, ...formData },
//     {
//       timeout: 36e5,
//     }
//   )
//   let data = res.data.choices[0].message
//   data.time = moment().format('YYYY-MM-DD HH:mm:ss')
//   formData.messages.push(data)
//   nextTick(scrollHandle)
// }

const submitHandle = async () => {
  // const eventSource = new EventSource(
  //   'https://api.deepseek.com/chat/completions'
  // )
  // eventSource.onmessage = function (event) {
  //   const message = event.data
  //   const messagesDiv = document.getElementById('messages')
  //   const newMessage = document.createElement('p')
  //   newMessage.textContent = message
  //   messagesDiv.appendChild(newMessage)
  // }

  // eventSource.onerror = function (error) {
  //   console.error('EventSource error:', error)
  //   eventSource.close()
  // }

  reactiveData.loading = 2

  try {
    // const response = await fetch('https://api.deepseek.com/chat/completions', {
    //   method: 'POST', // 请求方法
    //   headers: {
    //     Authorization: '', // 自定义请求头
    //     'Content-Type': 'application/json', // 指定内容类型
    //   },
    //   body: JSON.stringify({
    //     model: 'deepseek-chat',
    //     messages: formData.messages,
    //     stream: true,
    //   }), // 将数据序列化为 JSON
    // })
    // const response = await fetch(
    //   process.env.VUE_APP_baseURL + '/Api/DeepSeekStream',
    //   {
    //     method: 'POST', // 请求方法
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({ messages: formData.messages, ...formData }), // 将数据序列化为 JSON
    //   }
    // )
    let { data: res } = await DeepSeekCheck(null, { disable_loading: true })
    reactiveData.controller = new AbortController()
    const signal = reactiveData.controller.signal
    const response = await fetch(
      'https://dpapi.xiansuotu.com/index.php/index/v2_2',
      {
        method: 'POST', // 请求方法
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          code: res.data,
        }), // 将数据序列化为 JSON
        signal,
      }
    )
    const reader = response.body.getReader() // 获取流式响应的读取器

    let data = {
      role: 'assistant',
      content: '',
    }
    data.time = moment().format('YYYY-MM-DD HH:mm:ss')

    while (reactiveData.loading) {
      const { done, value } = await reader.read() // 读取流中的数据
      if (done) break // 如果流结束，退出循环

      const chunk = new TextDecoder('utf-8').decode(value) // 将二进制数据解码为文本
      const lines = chunk.split('\n\n') // SSE 数据以两个换行符分隔
      const events = lines
        .map((line) => {
          const data = line
            .trim()
            .split('\n')
            .filter((l) => {
              if (l === 'data: [DONE]') {
                reactiveData.loading = 0
              }
              return l.startsWith('data: ') && l !== 'data: [DONE]'
            })
          return data.map((d) => JSON.parse(d.slice(6))) // 去掉 "data: " 并解析为 JSON
        })
        .flat() // 将多层数组展平

      for (const item of events) {
        if (item.choices[0].delta.content) {
          if (reactiveData.loading === 2) {
            formData.messages.push(data)
            reactiveData.loading = 1
          }
          if (reactiveData.loading) {
            formData.messages[formData.messages.length - 1].content +=
              item.choices[0].delta.content
          }
        }
      }
    }
  } catch (error) {
    reactiveData.loading = 0
    console.log(error)
  } finally {
    reactiveData.loading = 0
  }
}

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      formData.messages.push({ role: 'user', content: formData.keyword })
      formData.keyword = ''
      submitHandle()
    } else {
      console.log('error submit!', fields)
    }
  })
}

const copyHandle = (value) => {
  copyText(value, undefined, (error, event) => {
    if (error) {
      ElMessage.error('复制失败')
    } else {
      ElMessage.success('复制成功')
    }
  })
}

const clearHandle = () => {
  reactiveData.controller.abort()
  reactiveData.loading = 0
  nextTick(() => {
    formData.messages = []
  })
}

const updateHandle = async (index) => {
  formData.messages.splice(index)
  submitHandle()
}

const text1Handle = () => {
  formData.keyword =
    '帮我给[产品]写一篇推广文案，介绍产品或服务特点，不超过300字。'
}
const text2Handle = () => {
  formData.keyword =
    '帮我生成一篇关于[主题]的小红书文案。文案需要包含标题和正文标题需根据主题改编为小红书风格，适当使用 emoji 来增强视觉吸引力和情感表达。'
}

const modelChangeHandle = () => {
  formData.model =
    formData.model === 'deepseek-reasoner'
      ? 'deepseek-chat'
      : 'deepseek-reasoner'
}
</script>

<style lang="scss" scoped>
.header {
  color: #fff;
  background-color: transparent;
  .divider {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-bottom: 1px solid #1a264a;
  }
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .tips {
    margin-bottom: 30px;
    padding-left: 50px;
    padding-right: 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      color: #fff;
    }
    .el-button {
      border-color: #fd5050;
      background-color: #fd5050;
      color: #fff;
      width: 91px;
      height: 33px !important;
    }
  }
  .content_list {
    flex: auto;
    overflow-x: hidden;
    .item {
      padding: 10px;
      font-size: 14px;
      .user {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .content {
          background-color: #1055ff;
          color: #fff;
          border-radius: 10px;
        }
      }
      .assistant {
        position: relative;
        .content {
          background-color: #182b54;
          border-radius: 10px;
          white-space: pre-wrap;
        }
        .tools {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .t2 {
            cursor: pointer;
          }
        }
      }
    }
  }
  .form {
    flex: none;
    padding: 10px;
    border-top: 1px solid #1a264a;
    .el-button {
      border-color: #1a264a;
      &:focus,
      &:hover {
        --el-button-hover-bg-color: transparent !important;
        border-color: #3b517d;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .input {
      width: 100%;
      :deep(.el-textarea__inner) {
        padding-bottom: 80px;
        padding-right: 80px;
        padding-top: 15px;
        background: transparent;
        height: 65px;
        border-color: #5d70b8;
        .el-input__inner {
          font-size: 18px;
        }
      }
      .el-row {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        padding: 10px;
      }
      .btn1 {
        font-size: 12px;
        padding: 0 5px;
        line-height: 24px;
        border-radius: 12px;
        border: 1px solid #374570;
        cursor: pointer;
        display: flex;
        align-items: center;
        &.active {
          background-color: #1055ff;
        }
      }
      .submit {
        border: 0;
        background-color: #0c50ff;
        border-radius: 50%;
        width: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
.drawer_deepseek {
  .el-drawer__header {
    position: relative;
    margin-bottom: 0;
    padding-bottom: 20px;
  }
  .el-drawer__body {
    padding: 0;
  }
}
</style>
